import { PayloadAction } from "@reduxjs/toolkit";
import { City, County, State } from "types/State";
import { Geolocation, StatesState } from "types/State";

const setStates = (
  state: StatesState,
  action: PayloadAction<State[]>
): void => {
  state.states = action.payload;
};
const setGeolocation = (
  state: StatesState,
  action: PayloadAction<Geolocation>
): void => {
  state.geolocation = action.payload;
};

const setCounties = (
  state: StatesState,
  action: PayloadAction<County[]>
): void => {
  state.counties = action.payload;
};

const setCities = (state: StatesState, action: PayloadAction<City[]>): void => {
  state.cities = action.payload;
};

const reducers = {
  setStates,
  setCounties,
  setCities,
  setGeolocation,
};

export default reducers;
